var _defs, _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1490 1489.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#40afaa;stroke:#40afaa;}.cls-1,.cls-2{stroke-miterlimit:10;stroke-width:40px;}.cls-2{fill:none;stroke:#fff;}.cls-3{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 213.18,
    y: 213.11,
    width: 1256.82,
    height: 1256.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20,
    y: 20,
    width: 1256.82,
    height: 1256.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M725.6,308.63v19.61l-33.18,3V636.92l33.18,3.52v20.11H608.46V640.44l34.19-3.52V332.26h-1.51l-95,328.29H520L420.44,332.76h-1.51V636.92l31.17,3.52v20.11H362.62V640.44l28.66-3.52V331.25l-28.66-3V308.63H465.18l78.93,267.46h1.51L623,308.63Z",
    transform: "translate(-5 -5.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.25,791.59c75.41,0,132.22,21.62,132.22,98,0,88-64.35,109.6-143.78,109.6h-16.6v120.65l55.31,3.52v20.11H744.61v-20.11l38.21-3.52V814.71l-38.21-3.52v-19.6Zm-28.16,184.5h21.62c57.82,0,82.45-28.15,82.45-84,0-56.8-25.13-77.42-79.93-77.42H834.09Z",
    transform: "translate(-5 -5.04)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.2f995c7884d56b1f2e771e1953f9f90d.svg";
export { ForwardRef as ReactComponent };